import React from 'react';
import { Scissors, ShoppingBag, Heart, UserCircle2, PenTool, Leaf, Palette, Sparkles } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: <Scissors className="h-12 w-12 text-emerald-400" />,
      title: "Custom Fashion Design",
      description: "Bespoke couture designs tailored to individual preferences, creating luxury gowns and statement pieces."
    },
    {
      icon: <ShoppingBag className="h-12 w-12 text-emerald-400" />,
      title: "Ready-to-Wear Collections",
      description: "Seasonal fashion collections featuring the latest trends and high-quality clothing for all."
    },
    {
      icon: <Heart className="h-12 w-12 text-emerald-400" />,
      title: "Bridal & Wedding Couture",
      description: "Exclusive bridal wear with intricate detailing and custom wedding attire for the entire party."
    },
    {
      icon: <UserCircle2 className="h-12 w-12 text-emerald-400" />,
      title: "Fashion Consulting",
      description: "Personal styling services and wardrobe curation for individuals and celebrities."
    },
    {
      icon: <PenTool className="h-12 w-12 text-emerald-400" />,
      title: "Fashion Sketching",
      description: "Hand-drawn and digital fashion illustrations with sample garment prototyping."
    },
    {
      icon: <Leaf className="h-12 w-12 text-emerald-400" />,
      title: "Sustainable Fashion",
      description: "Eco-friendly and ethically sourced fashion collections with sustainable materials."
    },
    {
      icon: <Palette className="h-12 w-12 text-emerald-400" />,
      title: "Textile Innovation",
      description: "Custom fabric printing, embroidery, and innovative textile design solutions."
    },
    {
      icon: <Sparkles className="h-12 w-12 text-emerald-400" />,
      title: "Photography Services",
      description: "Professional photography for fashion, events, and personal branding, capturing elegance in every frame."
    }
  ];

  return (
    <section id="services" className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">Our Services</h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            We offer a comprehensive range of fashion design services, from bespoke couture to sustainable collections.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="p-6 border border-gray-800 rounded-lg hover:border-emerald-400 transition-colors">
              <div className="mb-6">{service.icon}</div>
              <h3 className="text-xl font-bold mb-4">{service.title}</h3>
              <p className="text-gray-400">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;